import { render, staticRenderFns } from "./ProjectViewContent.vue?vue&type=template&id=62d97a08&scoped=true&"
import script from "./ProjectViewContent.vue?vue&type=script&lang=js&"
export * from "./ProjectViewContent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewContent.vue?vue&type=style&index=0&id=62d97a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d97a08",
  null
  
)

export default component.exports